import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Nuova password" subtitle="Scegli una nuova password sicura">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div className="space-y-2">
          <Label>Nuova password</Label>
          <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
        </div>
        <div className="space-y-2">
          <Label>Conferma password</Label>
          <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
        </div>
        <Button type="submit" className="w-full rounded-lg" disabled={loading || !token} data-testid="reset-submit">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Reimposta password
        </Button>
        {!token && <p className="text-center text-sm text-destructive">Token mancante nel link.</p>}
      </form>
    </AuthLayout>
  );
}
